/**
 * Sett som `onUpdate` på motion-elementer som animerer opacity.
 *
 * framer-motion 11 kjører opacity som WAAPI-animasjon i nettleseren. Når den er
 * ferdig, settes sluttverdien først ved neste frame, mens WAAPI-animasjonen
 * fjernes med en gang (AcceleratedAnimation.mjs, `onfinish`). Chrome rekker å
 * tegne én frame med startverdien — opacity 0 — og elementet blinker bort.
 * Med `onUpdate` satt bruker framer-motion aldri WAAPI for elementet, og
 * animasjonen går i JS uten hullet (ClickUp: «Flicker i søknadsportalen»).
 */
export const keepOnMainThread = () => {};
